// extracted by mini-css-extract-plugin
export default {"labelWrapper":"label_labelWrapper__4tOL7","asterisk":"label_asterisk__XLdVi"};